/* src/app/global/components/global-settings-select-deputy/global-settings-select-deputy.component.scss */
:host .cw-error-message {
  color: var(--color-accent);
}
/*# sourceMappingURL=global-settings-select-deputy.component.css.map */
